<!-- <h2>Job listings</h2>

<div *ngFor="let l of jobListings" class="card">
  <div class="card-body">
    <h5 *ngIf="l.fields['role']" class="card-title">
      {{ l.fields['role'] }}
    </h5>

    <h6 *ngIf="l.fields['organization'] || l.fields['date']"  class="card-subtitle">
      {{ l.fields['organization'] }} - {{ l.fields['date'] }}
    </h6>

    <div *ngIf="l.fields['description']" class="card-text">
      <p>
        {{ l.fields['description'] }}
      </p>
    </div>
    <a routerLink = "/listing/{{l.sys.id}}" class="btn btn-primary">
      More Details
    </a>
    
  </div>
</div> -->

<div class="header-container"
  [class.is-inverted]="isInverted">

  <div class="header-content">

    <div class="header-logo-container"
      [class.is-inverted]="isInverted">
      <a routerLink="/">
        lcp
      </a>
    </div>

    <nav class="header-nav-container"
      [class.is-inverted]="isInverted"
      [class.nav-active]="shouldShowMenu"> 
      
      <div class="header-menu-container--default">
        <ng-content *ngTemplateOutlet="ngContentTemplateHeaderNav">
        </ng-content>
      </div>

      <div class="header-menu-container--mobile">
        <!-- <fa-icon icon="bars"></fa-icon> -->
        <a class="header-menu-mobile-icon"
          (click)="toggleMobileMenu()">

          <!-- <fa-icon [icon]="faBars" size="lg"></fa-icon> -->

          <div class="burger">
            <div class="line line-1"></div>
            <div class="line line-2"></div>
            <div class="line line-3"></div>
          </div>
        </a>

        <div class="header-menu-mobile-menu-container">
          <div class="header-menu-mobile-menu"
            [class.is-visible]="shouldShowMenu">
            <ng-content *ngTemplateOutlet="ngContentTemplateHeaderNav">
            </ng-content>
          </div>
        </div>
      </div>
    </nav>
  </div>
</div>

<ng-template #ngContentTemplateHeaderNav>
  <ul>
    <li *ngFor="let navItem of navItems" class="header-nav-item">
      <!-- {{ navItem | json }} -->
      <a [routerLink]="navItem.fields['link']"
        [routerLinkActive]="navItem.fields['link'] && 'is-active'"
        [routerLinkActiveOptions]="{ exact: true }">
        {{ navItem.fields['display'] }}
      </a>
    </li>
  </ul>
</ng-template>
